import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	input,
	output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { TagComponent } from '@valk-nx/components/ui-tag/src/lib/tag';
import { SmartLinkComponent } from '@valk-nx/core/lib/components/smart-link/smart-link.component';
import { cn } from '@valk-nx/core/lib/core';

import { LinkListItem } from './link-list.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-link-list`,
	templateUrl: './link-list.component.html',
	imports: [
		AngularSvgIconModule,
		CommonModule,
		RouterModule,
		SmartLinkComponent,
		TagComponent,
		TranslatePipe,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LinkListComponent {
	cn = cn;

	linkListItems = input.required<LinkListItem[]>();

	showIcons = input(true);
	showDivider = input(true);
	showBorderTop = input(false);
	useChevron = input(false);
	preventNavigation = input(false);

	className = input('');

	linkClicked = output<LinkListItem>();

	onItemClick(event: MouseEvent, link: LinkListItem) {
		if (this.preventNavigation()) {
			event.preventDefault();
		}
		this.linkClicked.emit(link);
	}
}
